import { FC, useCallback, useState } from 'react';

import classNames from 'classnames';

import { IMacCardInfo } from '../../../store/mac.slice';

import { MacCard } from './MacCard';

export interface IMacCardsSelectedProps {
  selectedCards: IMacCardInfo[];
  onCardZoom?: (zoomed: boolean) => void;
  /** Групповая терапия: 6 столбцов вместо 4 */
  isGroupTherapy?: boolean;
  /** Ответы психолога: на всю высоту контейнера, 4 колонки, ширина по высоте, без вертикального скролла */
  fillContainerHeight?: boolean;
}
export const MacCardsSelected: FC<IMacCardsSelectedProps> = ({
  selectedCards,
  onCardZoom,
  isGroupTherapy,
  fillContainerHeight,
}) => {
  const [zoomedId, setZoomedId] = useState<number | null>(null);

  const onCardZoomHandler = useCallback(
    (isZoomed: boolean, id: number) => {
      if (isZoomed) {
        setZoomedId(id);
        onCardZoom && onCardZoom(true);
      } else {
        setZoomedId(null);
        onCardZoom && onCardZoom(false);
      }
    },
    [onCardZoom],
  );

  const filteredCards = selectedCards.filter((c) => (zoomedId ? c.id === zoomedId : true));

  if (!isGroupTherapy && !fillContainerHeight) {
    return (
      <div
        className={classNames('bg-ink-muted rounded-card p-3 gap-[10px] grid ', {
          'content-center overflow-y-auto': !zoomedId,
          'overflow-hidden justify-center min-w-[40vw]': zoomedId,
          'grid-cols-1 min-w-[40vw]': !zoomedId && selectedCards.length <= 2,
          'grid-cols-2 min-w-[40vw]': !zoomedId && selectedCards.length >= 3,
        })}
        style={{
          opacity: selectedCards.length > 0 ? 1 : 0,
          pointerEvents: selectedCards.length > 0 ? 'auto' : 'none',
        }}
      >
        {filteredCards.map((item) => (
          <MacCard key={item.id} id={item.id} img={item.img} onZoomToggle={(z) => onCardZoomHandler(z, item.id)} />
        ))}
      </div>
    );
  }

  // Групповая терапия, результаты психолога: блок карт по центру, gap 12px, карты на всю высоту
  if (fillContainerHeight && !zoomedId) {
    const rowCount = Math.ceil(filteredCards.length / 4) || 1;
    return (
      <div
        className="flex justify-center items-center h-full min-h-0 flex-1 rounded-control"
        style={{
          opacity: selectedCards.length > 0 ? 1 : 0,
          pointerEvents: selectedCards.length > 0 ? 'auto' : 'none',
        }}
      >
        <div
          className="grid h-full gap-[12px] w-max max-w-full"
          style={{ gridTemplateColumns: 'repeat(4, auto)', gridTemplateRows: `repeat(${rowCount}, 1fr)` }}
        >
          {filteredCards.map((item) => (
            <div key={item.id} className="min-h-0 flex justify-center items-stretch overflow-hidden">
              <div className="h-full w-auto aspect-[110/140] overflow-hidden rounded-card">
                <MacCard id={item.id} img={item.img} />
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  const rowCount = fillContainerHeight ? Math.ceil(filteredCards.length / 4) || 1 : undefined;

  return (
    <div
      className={classNames('rounded-control grid', {
        'gap-[10px] content-center overflow-y-auto': !zoomedId && !fillContainerHeight,
        'overflow-hidden justify-center min-w-[40vw] grid-cols-1': zoomedId,
        'grid-cols-4 min-w-0 w-full': !zoomedId && !isGroupTherapy,
        'grid-cols-6 min-w-0 w-full': !zoomedId && isGroupTherapy,
      })}
      style={{
        opacity: selectedCards.length > 0 ? 1 : 0,
        pointerEvents: selectedCards.length > 0 ? 'auto' : 'none',
        ...(rowCount !== undefined && { gridTemplateRows: `repeat(${rowCount}, 1fr)` }),
      }}
    >
      {filteredCards.map((item) =>
        fillContainerHeight ? (
          <div key={item.id} className="min-h-0 min-w-0 flex justify-center items-stretch overflow-hidden">
            <div className="h-full w-auto aspect-[110/140] overflow-hidden">
              <MacCard id={item.id} img={item.img} />
            </div>
          </div>
        ) : (
          <MacCard
            key={item.id}
            id={item.id}
            img={item.img}
            onZoomToggle={fillContainerHeight || isGroupTherapy ? undefined : (z) => onCardZoomHandler(z, item.id)}
          />
        ),
      )}
    </div>
  );
};
